import { Link, useLocation } from "react-router-dom";
import { Home, Bot, MessageSquare, User } from "lucide-react";
import { useLanguage } from "@/App";

// Mobile-only persistent bottom navigation — 5 most-used destinations.
export default function BottomNav() {
  const { t } = useLanguage();
  const { pathname } = useLocation();
  const items = [
    { path: "/dashboard",    icon: Home,      ar: "الرئيسية",  en: "Home",     id: "home" },
    { path: "/ai-assistant", icon: Bot,       ar: "المساعد",    en: "AI",       id: "ai" },
    { path: "/messages",     icon: MessageSquare, ar: "الرسائل", en: "Messages", id: "messages" },
    { path: "/profile",      icon: User,      ar: "الحساب",    en: "Profile",  id: "profile" },
  ];
  const isActive = (p) => pathname === p || (p !== "/dashboard" && pathname.startsWith(p + "/"));
  return (
    <nav className="bottom-nav-bar lg:hidden" data-testid="bottom-nav" aria-label="primary navigation">
      {items.map((it) => {
        const active = isActive(it.path);
        return (
          <Link key={it.path} to={it.path} data-testid={`bnav-${it.id}`}
            className="flex flex-col items-center justify-center gap-0.5 flex-1 py-1 rounded-xl transition-colors"
            style={{ color: active ? "var(--accent-gold)" : "var(--text-secondary)" }}>
            <it.icon size={20} strokeWidth={active ? 2.4 : 2} />
            <span className="text-[10px] font-bold leading-tight">{t(it.ar, it.en)}</span>
          </Link>
        );
      })}
    </nav>
  );
}
